
import { motion } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';
import { Link } from 'react-router-dom';
import { countries, CountryRegions } from '@/data/regions';

interface CountryRegionsLinksProps {
  countryId?: string;
  alwaysShowMainCountries?: boolean;
}

export const CountryRegionsLinks = ({ countryId, alwaysShowMainCountries = false }: CountryRegionsLinksProps) => {
  const { language } = useLanguage();
  
  // Determine which countries to display
  let filteredCountries = countries;
  
  if (!alwaysShowMainCountries && countryId) {
    // Filter to show only the selected country if countryId is provided
    filteredCountries = countries.filter(country => 
      country.value === countryId || 
      (countryId === 'germany' && country.value === 'de') ||
      (countryId === 'austria' && country.value === 'at') ||
      (countryId === 'switzerland' && country.value === 'ch')
    );
  } else if (alwaysShowMainCountries) {
    // When alwaysShowMainCountries is true, always show Germany and Austria
    filteredCountries = countries.filter(country => 
      country.value === 'de' || country.value === 'at'
    );
  }

  return (
    <div className="space-y-8">
      {filteredCountries.map((country) => (
        <motion.div 
          key={country.value}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="bg-white rounded-lg shadow-sm p-6"
        >
          <h3 className="text-xl font-semibold mb-4 text-gray-800">{country.name[language === 'de' ? 'de' : 'en']}</h3>
          <div className="flex flex-wrap gap-2">
            {country.regions.map((region) => (
              <Link 
                key={region.value}
                to={`/${country.value}/${region.value}`}
                className="px-3 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-full text-sm transition-colors"
              >
                {region.name[language === 'de' ? 'de' : 'en']}
              </Link>
            ))}
          </div>
        </motion.div>
      ))}
    </div>
  );
};
